import SlsCanalVendaClient from '@/api/Cadastros/info-organizacionais/sls-canal-venda.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSCanalVendaService {
  constructor() {
    this.client = new SlsCanalVendaClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os canal-venda');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar CanalVenda');
    }
  }

  async show(id) {
    try {
      return await this.client.show(id);
    } catch (error) {
      this.error.message(error, 'Erro ao buscar CanalVenda');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.client.update(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar CanalVenda');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar CanalVenda');
    }
  }
}
